// Mock data for Highland Institute website

export const heroSlides = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/lwlrw0zw_Image%20with%20Easterine%20and%20Dancers%20during%20Bookaroo.jpg",
    title: "Imagine. Discover. Care",
    subtitle: "The Highland Institute promotes creative thinking through interactive community events."
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/i370c9km_Highland%20Institute%20Exhibition.jpg",
    title: "Debate. Community Engagement. Fellowship",
    subtitle: "Fostering critical debate, testing ideas, exploring together"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/5bhv269k_Nagaland%20Landscape.jpg",
    title: "Learn. Research. Belong.",
    subtitle: "The Highland Institute nurtures knowledge rooted in place, people, and shared inquiry."
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/4wosxad0_Fieldwork%20Film.jpg",
    title: "Dream. Design. Build.",
    subtitle: "Join us in co-creating sustainable futures through Indigenous knowledge systems."
  }
];

export const newsEvents = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/zpk9z89o_Bereneice-Bower%20Lectures.png",
    category: "The Bower Lectures",
    title: "Tangled Lands: Burma and India's Unfinished Separation",
    description: "Dr Bérénice Guyot-Réchard, Reader (Associate Professor) in International and South Asian History at Kings College London, delivered the 12th Annual Ursula Graham Bower Lectures.",
    link: "/bower-lectures"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/cj32pbr1_NEN-Biodiversity%20Festival.png",
    category: "Fieldwork and Research",
    title: "16th NEN Biodiversity Festival",
    description: "6th – 7th March 2025. Theme: 'Nurturing Health, Wellbeing, and Resilience: Sustaining Our Future Together'.",
    link: "/fieldwork"
  },
  {
    id: 3,
    image: "https://highlandinstitute.org/wp-content/uploads/2025/10/1.jpg",
    category: "Blog",
    title: "From Lore to Life: Grandpa's Hands, A Channel of Divine Healing",
    description: "By Lino K. Zhimomi - Back in 1968 in Hovukhü village, Grandpa savoured a rich and satisfying meal that included an otter...",
    link: "https://highlandinstitute.org/from-lore-to-life-grandpas-hands-a-channel-of-divine-healing/"
  }
];

export const researchProjects = [
  {
    id: 1,
    slug: "war-residues",
    image: "https://customer-assets.emergentagent.com/job_content-upgrade-11/artifacts/dtcmgynk_image.jpg",
    title: "War Residues",
    subtitle: "Objects, Memory, and the Legacy of WWII along the Naga–Myanmar Border",
    description: "Supported by the Delta on the Move Foundation, the War Residues project explores how memories of the Second World War continue to circulate through everyday objects and oral histories in the highland borderlands of Nagaland and Myanmar. Often described as a 'Forgotten War', WWII profoundly shaped Naga communities along the India–Myanmar borderlands.",
    link: "/research/war-residues"
  },
  {
    id: 2,
    slug: "ekologos",
    image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/kp2xwc0c_SAS%20Environmental%20Studies.jpeg",
    title: "Ekologos: A Global Environmental Project",
    subtitle: "Has the Amazon rainforest's destruction reached a tipping point?",
    description: "Prof. Luiz Marques, member of the Ekologos project funded by the Highland Institute and the Norwegian Directorate of Higher Education, investigates tipping points that could trigger cascading climate effects, such as shifting rainfall patterns, intensifying wildfires, and accelerating continental forest loss in the Amazon rainforest.",
    link: "https://journals.highlanderpress.org/index.php/Highlander/article/view/2/2"
  },
  {
    id: 3,
    slug: "mycclimate",
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/oszwxqrk_MyCClimate%20Project%20Landscape%20Fieldwork%20Earthkeepers.jpg",
    title: "MyCClimate",
    subtitle: "Community Responses to Climate Change in Highland Asia",
    description: "Funded by the Danish Institute of International Studies, the MyCClimate project at the Highland Institute explores community-driven strategies addressing climate impacts on local livelihoods and ecosystems in Highland Asia, emphasizing resilience, adaptation, and indigenous environmental knowledge.",
    link: "https://journals.highlanderpress.org/index.php/Highlander/article/view/14/13"
  },
  {
    id: 4,
    slug: "tasting-tomorrow",
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/vroc0nae_Tasting%20Tomorrow.png",
    title: "Tasting Tomorrow",
    subtitle: "Cultural Heritage and Climate Change Through Food",
    description: "Highland Institute researchers Tümüzo Katiry, Akumtong Imchen, and Saktum Wonti investigated how cultural heritage can adapt to climate change through food and cuisine, preparing popular Naga dishes with ingredients likely available after 50 years of climate change.",
    link: "https://journals.highlanderpress.org/index.php/Highlander/article/view/4/17"
  },
  {
    id: 5,
    slug: "plurimed",
    image: "https://customer-assets.emergentagent.com/job_roadwise-asia/artifacts/19qqt0ph_SAS%20Health%20Sciences.JPG",
    title: "PluriMed",
    subtitle: "Entangled Medical Futures: Health in Climate-Altered Highland Asia",
    description: "Dr. Michael T. Heneise leads an international workshop at the University of Edinburgh exploring how indigenous and plural medical systems respond to climate-driven health challenges, highlighting sustainable care practices and innovative community health strategies.",
    link: "https://journals.highlanderpress.org/index.php/Plurimed"
  }
];

export const perspectives = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/sfm7rw4t_Fieldwork%20Exploration.jpg",
    title: "Staff Blog",
    description: "Read insights from our researchers and staff",
    link: "https://blogs.highlanderpress.org"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/pi7pletb_Highland%20on%20Facebook.png",
    title: "Highland on Facebook",
    description: "Follow our news and events",
    link: "https://www.facebook.com/highlandinstitute"
  }
];

export const exploreOptions = [
  {
    id: 1,
    slug: "highland-global",
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/lhm44vsg_Highland%20Global%20-%20Saki%20Trip%20to%20Fiji.jpg",
    title: "Highland Global",
    subtitle: "Connecting the Highlands to the World",
    description: "International research networks, institutional partnerships, and the contributions of visiting scholars and global collaborators.",
    links: [
      { label: "Global Collaborations", url: "/highland-global#collaborations" },
      { label: "Institutional Partners", url: "/highland-global#partners" },
      { label: "International Conferences & Workshops", url: "/highland-global#conferences" },
      { label: "Visiting Scholars & Fellows", url: "/highland-global#scholars" },
      { label: "Partner With Us", url: "/highland-global#partner" }
    ]
  },
  {
    id: 2,
    slug: "highland-local",
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/rsn0xi45_Highland%20Local%20Community%20Knowledge%20Games.jpg",
    title: "Highland Local",
    subtitle: "Rooted Collaborations, Community Knowledge",
    description: "From long-term field research to local school partnerships, public exhibitions, and citizen science initiatives, here are everyday engagements that shape our research and learning environments.",
    links: [
      { label: "Local Research Networks", url: "/highland-local#research" },
      { label: "Schools & Citizen Science Projects", url: "/highland-local#schools" },
      { label: "Community Archives & Oral Histories", url: "/highland-local#archives" },
      { label: "Public Exhibitions & Events", url: "/highland-local#events" },
      { label: "Engage Locally", url: "/highland-local#engage" }
    ]
  },
  {
    id: 3,
    slug: "study-with-us",
    image: "https://customer-assets.emergentagent.com/job_institute-clone/artifacts/uy0foh7q_Study%20with%20Us%20Film%20Studies.jpg",
    title: "Study With Us",
    subtitle: "Internship Programme & Research Training",
    description: "Our interns gain hands-on training in field methods, research ethics, and proposal development under expert mentorship.",
    links: [
      { label: "Explore the Internship Programme", url: "/study-with-us#internship" },
      { label: "Overview, Timeline, and Eligibility", url: "/study-with-us#overview" },
      { label: "PGCertR Pathway", url: "/study-with-us#pgcertr" },
      { label: "Research Themes & Projects", url: "/study-with-us#themes" },
      { label: "Mentors & Faculty", url: "/study-with-us#faculty" },
      { label: "Get Certified", url: "/study-with-us#certification" }
    ]
  }
];

export const navigationLinks = [
  { label: "About", path: "/about" },
  { label: "Research", path: "/research" },
  { label: "Events", path: "/events" },
  { label: "Programmes", path: "/programmes" },
  { label: "Community", path: "/community" },
  { label: "Library", path: "/library" },
  { label: "Contact", path: "/contact" }
];

export const aboutContent = {
  mission: "The Highland Institute is a research and educational institution dedicated to promoting sustainable futures through indigenous knowledge systems, community engagement, and rigorous academic inquiry.",
  vision: "We envision a world where indigenous wisdom and modern scholarship converge to address pressing environmental and social challenges, fostering resilient communities rooted in place and tradition.",
  values: [
    "Community-centered research",
    "Indigenous knowledge systems",
    "Environmental sustainability",
    "Cross-cultural dialogue",
    "Academic excellence"
  ]
};